import { useEffect, useState } from 'react';
import { AsyncResult } from '../types/AsyncResult';

/** Takes a promise and returns a {loading, error, data} map representing its state.
 *
 * Be careful to not pass a new promise on every render!
 */
export const usePromise = <T>(promise: PromiseLike<T> | null): AsyncResult<T> => {
  const [state, setState] = useState<AsyncResult<T>>({ loading: true });

  useEffect(() => {
    setState({ loading: true });
    let cancelled = false;

    if (promise) {
      promise.then(
        value => {
          if (!cancelled) setState({ loading: false, error: undefined, data: value });
        },
        (error: unknown) => {
          if (!cancelled) setState({ loading: false, error });
        },
      );
    }

    return () => {
      cancelled = true;
    };
  }, [promise]);

  return state;
};
